import PicoContext from './PicoContext';

const contexts = new Map<string, PicoContext>();

const getContext = (dirname: string): PicoContext => {
    let context = contexts.get(dirname);
    if (typeof context === 'undefined') {
        context = new PicoContext(dirname);
        contexts.set(dirname, context);
    }
    return context;
};

const PicoUtils = {
    getContext,
};

export default PicoUtils;
